import type { HTMLAttributes } from "react";

import { cn } from "@/lib/utils";
import { ReportProblemButton } from "@/components/ReportProblemButton";

type AlertProps = HTMLAttributes<HTMLDivElement> & {
  variant?: "error" | "success" | "info";
};

/**
 * Messages the user has to act on.
 *
 * `role="alert"` so a screen reader announces a failed login rather than
 * leaving the user wondering why nothing happened.
 */
export function Alert({ className, variant = "info", children, ...props }: AlertProps) {
  const tone = {
    error:
      "border-destructive bg-red-50 text-destructive",
    success: "border-success bg-emerald-50 text-success",
    info: "border-border bg-muted text-foreground",
  }[variant];

  return (
    <div
      role="alert"
      className={cn("rounded-md border px-4 py-3 text-sm", tone, className)}
      {...props}
    >
      {children}
      {variant === "error" && typeof children === "string" && <span className="mt-2 block"><ReportProblemButton message={children} /></span>}
    </div>
  );
}
